import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboardStats } from '../../services/dashboard';

const StatsCards = () => {
  const navigate = useNavigate();
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const response = await getDashboardStats();
      if (response && response.success !== false && response.data) {
        setStatsData(response.data);
      }
    } catch (error) {
      console.error('Failed to load dashboard stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const stats = statsData ? [
    {
      title: 'Total Licences',
      value: statsData.totalLicences?.value?.toString() || '0',
      change: statsData.totalLicences?.change || '0',
      changeType: statsData.totalLicences?.changeType || 'neutral',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M16.6667 5.83333H3.33333C2.8731 5.83333 2.5 6.20643 2.5 6.66667V15C2.5 15.4602 2.8731 15.8333 3.33333 15.8333H16.6667C17.1269 15.8333 17.5 15.4602 17.5 15V6.66667C17.5 6.20643 17.1269 5.83333 16.6667 5.83333Z" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M13.3333 5.83333V4.16667C13.3333 3.72464 13.1577 3.30072 12.8452 2.98816C12.5326 2.67559 12.1087 2.5 11.6667 2.5H8.33333C7.89131 2.5 7.46738 2.67559 7.15482 2.98816C6.84226 3.30072 6.66667 3.72464 6.66667 4.16667V5.83333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Active Licences',
      value: statsData.activeLicences?.value?.toString() || '0',
      change: statsData.activeLicences?.change || '0',
      changeType: statsData.activeLicences?.changeType || 'neutral',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7.5 10H12.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 7.5V12.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Pending Requested Translations',
      value: statsData.pendingTranslationRequests?.value?.toString() || '0',
      change: statsData.pendingTranslationRequests?.change || '0',
      changeType: statsData.pendingTranslationRequests?.changeType || 'neutral',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M10 2.5L2.5 7.5V12.5L10 17.5L17.5 12.5V7.5L10 2.5Z" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 10L7.5 8.75V11.25L10 12.5L12.5 11.25V8.75L10 10Z" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Pending Requests',
      value: statsData.pendingRequests?.value?.toString() || '0',
      change: statsData.pendingRequests?.change || '0',
      changeType: statsData.pendingRequests?.changeType || 'neutral',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M10.8333 1.66667L2.5 11.6667H10L9.16667 18.3333L17.5 8.33333H10L10.8333 1.66667Z" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Approved Licences',
      value: statsData.approvedLicences?.value?.toString() || '0',
      change: statsData.approvedLicences?.change || '0',
      changeType: statsData.approvedLicences?.changeType || 'neutral',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M16.6667 8.33333L7.5 17.5L3.33333 13.3333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Expired Licences',
      value: statsData.expiredLicences?.value?.toString() || '0',
      change: statsData.expiredLicences?.change || '0',
      changeType: statsData.expiredLicences?.changeType || 'decrease',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M15 5L5 15M5 5L15 15" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ] : [];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 animate-pulse">
            <div className="h-20 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  const statsArray = stats || [];

  const handleCardClick = (title) => {
    // Navigate to requested licenses page with appropriate tab based on card clicked
    if (title === 'Total Licences') {
      navigate('/requested-licences?tab=All');
    } else if (title === 'Active Licences') {
      navigate('/requested-licences?tab=Licence Granted');
    } else if (title === 'Approved Licences') {
      navigate('/requested-licences?tab=Licence Granted');
    } else if (title === 'Expired Licences') {
      navigate('/requested-licences?tab=Expired');
    } else if (title === 'Pending Requests') {
      navigate('/requested-licences?tab=Pending');
    } else if (title === 'Pending Requested Translations') {
      // navigate('/requested-licences?tab=Translation Requests');
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4">
      {statsArray.map((stat, index) => {
        const isClickable = stat.title === 'Total Licences' ||
                           stat.title === 'Active Licences' ||
                           stat.title === 'Approved Licences' ||
                           stat.title === 'Expired Licences' ||
                           stat.title === 'Pending Requests' ||
                           stat.title === 'Pending Requested Translations';
        return (
          <div 
            key={index} 
            onClick={() => isClickable && handleCardClick(stat.title)}
            className={`bg-white rounded-xl shadow-sm border border-gray-200 p-5 ${
              isClickable ? 'cursor-pointer hover:shadow-md hover:border-emerald-300 transition-all' : ''
            }`}
          >
            <div className="flex items-start gap-3">
              <div className="p-3 bg-emerald-50 rounded-lg shrink-0">
                <div className="text-emerald-400">
                  {stat.icon}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-gray-500 mb-1">{stat.title}</p>
                <p className="text-3xl font-bold text-gray-900 leading-none mb-2">{stat.value}</p>
                <div className="flex items-center gap-1">
                  {stat.changeType === 'increase' && (
                    <>
                      <svg className="w-3 h-3 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17L17 7M17 7H7M17 7V17" />
                      </svg>
                      <span className="text-xs font-medium text-emerald-400">{stat.change}</span>
                      <span className="text-xs text-gray-400">Last month</span>
                    </>
                  )}
                  {stat.changeType === 'decrease' && (
                    <>
                      <svg className="w-3 h-3 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 7L7 17M7 17H17M7 17V7" />
                      </svg>
                      <span className="text-xs font-medium text-red-400">{stat.change}</span>
                      <span className="text-xs text-gray-400">Last month</span>
                    </>
                  )}
                  {stat.changeType === 'neutral' && (
                    <>
                      <span className="text-xs font-medium text-gray-400">{stat.change}</span>
                      <span className="text-xs text-gray-400">Last month</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsCards;
